import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ActivatedRoute, ActivatedRouteSnapshot, Data } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { BehaviorSubject, Observable, filter } from 'rxjs';

interface Crumb {
  url: string;
  title: string;
}

@Injectable({
  providedIn: 'root'
})
export class BreadCrumbsService {
  public crumbs: Crumb[] = [];
  public currentCrumb: Crumb;

  public breadCrumbsData: BehaviorSubject<{ title: string; url: string }> = new BehaviorSubject(null);

  public breadCrumbs: Observable<{ title: string; url: string }> = this.breadCrumbsData.asObservable();

  private oldTitle: string;

  private previusUrl: string;

  constructor(private _router: Router, private route: ActivatedRoute, private title: Title) {
    this._router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      const eventUrl: string = event.url;

      if (eventUrl.includes('list')) {
        this.previusUrl = eventUrl;

        if (this.get()['title']) {
          this.oldTitle = this.get()['title'];
        } else {
          throw new Error('route has not title propertie, please add this to router data');
        }

        this.breadCrumbsData.next(null);
      }

      if (event.url === '/') {
        this.oldTitle = '';
        this.setPageTilte('DCBM ADMIN ACCUEIL');
      }

      if (event.url.includes('login')) {
        this.oldTitle = '';
        this.setPageTilte('DCBM-ADMIN Page de connexion');
      }

      /*   const actMatcher = RegExp(/\/data\/.*\/edit\//);

        if (actMatcher.test(event['url'])) {
          const lastCrumb = this.crumbs[this.crumbs.length - 1];

          if (this.crumbs.length > 0 && lastCrumb?.url !== event.url) {
            this.crumbs.push({ url: event.url, title: this.title.getTitle() });
          }

          if (!lastCrumb) this.crumbs.push({ url: event.url, title: this.title.getTitle() });

          this.breadCrumbsData.next({ title: this.oldTitle, url: this.previusUrl });
        } */
    });
  }

  public setPageTilte(title: string) {
    this.title.setTitle(title);
  }

  private getRouteSnapshot(): ActivatedRouteSnapshot {
    let route = this.route;

    while (route.firstChild) {
      route = route.firstChild;
    }

    return route.snapshot;
  }

  get(): Data {
    return this.getRouteSnapshot().data;
  }

  public navigate(url: string) {
    this._router.navigate([url]);
  }
}
